module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzIiBoZWlnaHQ9IjE4IiB2aWV3Qm94PSIwIDAgMyAxOCI+CiAgICA8ZyBmaWxsPSIjOUI5QjlCIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxjaXJjbGUgY3g9IjEuNSIgY3k9IjEuNSIgcj0iMS41Ii8+CiAgICAgICAgPGNpcmNsZSBjeD0iMS41IiBjeT0iOC41IiByPSIxLjUiLz4KICAgICAgICA8Y2lyY2xlIGN4PSIxLjUiIGN5PSIxNi41IiByPSIxLjUiLz4KICAgIDwvZz4KPC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/more-dots-vertical.svg
// module id = 2775
// module chunks = 0